<ion-app>
  <ion-menu contentId="main">
    <app-sidebar></app-sidebar>
  </ion-menu>

  <ion-router-outlet id="main"></ion-router-outlet>

  @if (debug) {
    <app-bart></app-bart>
  }
</ion-app>
